import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { useLogout } from "@/features/auth/hooks";
import { useIdleTimeout } from "@/lib/auth/idle-timeout";

export function IdleTimeoutModal() {
  const logout = useLogout();
  const { warning, dismiss } = useIdleTimeout(() => logout.mutate());
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    if (!warning) {
      setCountdown(60);
      return;
    }
    const timer = window.setInterval(() => setCountdown((c) => Math.max(0, c - 1)), 1000);
    return () => window.clearInterval(timer);
  }, [warning]);

  return (
    <Dialog open={warning} onOpenChange={(open) => !open && dismiss()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Session bientôt expirée</DialogTitle>
          <DialogDescription>
            Vous serez déconnecté dans <strong>{countdown}</strong> seconde{countdown > 1 ? "s" : ""}{" "}
            pour cause d'inactivité.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => logout.mutate()}>
            Se déconnecter
          </Button>
          <Button onClick={dismiss}>Continuer la session</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
